var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-fade-transition',{attrs:{"mode":"out-in"}},[(_vm.$store.state.user || _vm.render)?_c('router-view'):_c('loading-screen')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }